import React, {useState} from 'react';
import ContactCard from '../../elements/ContactCard';
import { CardContainer } from '../../elements';
import Modal from '../../elements/Modal';
import { View, ScrollView, Text } from 'react-native';
import {
  AddContactButton
} from './elements';
import NewContact from './new';

const Contacts = props => {
  const { contacts, sellerId, setUpdatedContactDetails } = props;
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  return (
    <>
      <br />
      <Text><b>Contacts</b></Text>
      <AddContactButton
        onPress={() => setShowAddContactModal(true)}
      >
        <Text>
          + Add Contact
        </Text>
      </AddContactButton>
      <ScrollView>

        <CardContainer>
          {contacts?.map(contact => {
            return(
              <ContactCard
                contact={contact}
                setShowModal={setShowAddContactModal}
                key={`contact${contact.id}`}
                setUpdatedContactDetails={setUpdatedContactDetails}
              />
            )
          })}
        </CardContainer>
        {showAddContactModal &&
          <Modal
            showModal={showAddContactModal}
            setShowModal={setShowAddContactModal}
            modalType={'Add Contact'}
          >
            <NewContact
              setShowModal={setShowAddContactModal}
              sellerId={sellerId}
              setUpdatedContactDetails={setUpdatedContactDetails}
            />
          </Modal>
        }
      </ScrollView>
    </>
  )
}

export default Contacts;